<template>
<div class="chapter">
<div class="inner_page">
<p><br/></p>
<p><br/></p>
<h1 class="sigil_not_in_toc"><i>Section 1</i></h1>
<h2 class="sec-head" id="sigil_toc_id_11" title="Section 1: Tools for Loving People with Addiction">Tools for Loving<br/>
  People with Addiction</h2>
<div>
<div class="chding"><img alt="cross" src="Images/4125_graphic_C.png" width="3%"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sec1.vue?7a421de6